import * as React from 'react'
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'

function SvgCheckBoxSelected({ title, titleId, ...props }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      aria-labelledby={titleId}
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fillRule="nonzero" fill="none">
        <rect
          stroke="#0D3577"
          fill={defaultTheme.ColorBaseBrandPrimary500}
          x={0.5}
          y={0.5}
          width={15}
          height={15}
          rx={2}
        />
        <path
          d="M10.88 4.376a1.196 1.196 0 011.767.03c.481.528.469 1.372-.027 1.885l-5.156 5.333a1.195 1.195 0 01-1.74 0L3.38 9.2a1.397 1.397 0 01-.027-1.886 1.196 1.196 0 011.767-.029L6.594 8.81l4.286-4.433z"
          fill="#FFF"
        />
      </g>
    </svg>
  )
}

export default SvgCheckBoxSelected
